<template>
  <div>
    <Modal v-model="visible" title="请选择需要结算的数据" width="1400" :mask-closable="false" :footer-hide="true" :fullscreen="true">
      <div class="search-container">
        <div class="search-box" :class="{ close: !searchMore }">
          <div class="input-item" v-if="$units.superviseShowVal()">
            <span class="label">供应商类型</span>
            <RadioGroup v-model="formData.supplierType" @on-change="changeSupplierType">
              <Radio label="">全部</Radio>
              <Radio label="1">保司</Radio>
              <Radio label="2">通道</Radio>
            </RadioGroup>
          </div>

          <div class="input-item" v-if="formData.supplierType">
            <span class="label">供应商</span>
            <Select v-model="formData.supplierId" placeholder="请选择" filterable clearable transfer>
              <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">保险公司</span>
            <Select v-model="formData.companyCode" placeholder="请选择" filterable clearable transfer>
              <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">产品名称</span>
            <Select v-model="formData.productCode" clearable transfer filterable>
              <Option :value="item.productCode" v-for="(item, index) in productList" :key="index">{{ item.productCode }}/{{ item.productName }}</Option>
            </Select>
          </div>

          <div class="input-item select-two">
            <Select v-model="dateType" :transfer="true">
              <Option value="1">投保日期</Option>
              <Option value="2">支付日期</Option>
              <Option value="3">承保日期</Option>
              <Option value="7">生效日期</Option>
            </Select>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="date"
              @on-change="date = $event"
            ></DatePicker>
          </div>

          <div class="input-item">
            <span class="label">保单号</span>
            <Input type="text" v-model="formData.policyNo" placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">保单状态</span>
            <Select v-model="formData.policyStatusList" clearable transfer multiple>
              <Option value="1">已承保</Option>
              <Option value="-1">已退保</Option>
              <Option value="0">已终止</Option>
              <Option value="2">已中止</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">回执状态</span>
            <Select
              v-model="formData.receiptStatusList"
              clearable
              transfer
              multiple
              :disabled="formData.receiptStatusNull && formData.receiptStatusNull.length ? true : false"
            >
              <Option value="-1">无需回执</Option>
              <Option value="0">待回执</Option>
              <Option value="1">回执成功</Option>
              <Option value="2">回执失败</Option>
            </Select>
            <CheckboxGroup
              v-model="formData.receiptStatusNull"
              style="margin-left: 10px; width: 100px"
              @on-change="changeTimeNull($event, 'receiptStatusList')"
            >
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item select-two">
            <Select v-model="dateType2" :transfer="true">
              <Option value="1">回执签收日期</Option>
              <Option value="2">回执回销日期</Option>
            </Select>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.date2"
              @on-change="formData.date2 = $event"
              :disabled="formData.dateTimeNull && formData.dateTimeNull.length ? true : false"
            ></DatePicker>
            <CheckboxGroup v-model="formData.dateTimeNull" style="margin-left: 10px; width: 60px" @on-change="changeTimeNull($event, 'date2')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">回访状态</span>
            <Select
              v-model="formData.verifyStatusList"
              clearable
              transfer
              multiple
              :disabled="formData.verifyStatusNull && formData.verifyStatusNull.length ? true : false"
            >
              <Option value="0">等待回访</Option>
              <Option value="1">回访成功</Option>
              <Option value="2">回访失败</Option>
              <Option value="3">无需回访</Option>
            </Select>
            <CheckboxGroup v-model="formData.verifyStatusNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'verifyStatusList')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">回访日期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.verifyDate"
              @on-change="formData.verifyDate = $event"
              :disabled="formData.revisitTimeNull && formData.revisitTimeNull.length ? true : false"
            ></DatePicker>
            <CheckboxGroup v-model="formData.revisitTimeNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'verifyDate')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>
          <div class="input-item">
            <span class="label">犹豫止期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.hesitateDate"
              @on-change="formData.hesitateDate = $event"
              :disabled="formData.hesitateTimeNull && formData.hesitateTimeNull.length ? true : false"
            ></DatePicker>
            <CheckboxGroup v-model="formData.hesitateTimeNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'hesitateDate')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>
          <div class="input-item">
            <span class="label">是否自保件</span>
            <RadioGroup v-model="formData.isSelfHold" @on-change="searchAjax()">
              <Radio label="">全部</Radio>
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </div>
          <div class="input-item">
            <span class="label">是否互保件</span>
            <RadioGroup v-model="formData.isMutualHold" @on-change="searchAjax()">
              <Radio label="">全部</Radio>
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </div>
          <div class="input-item">
            <span class="label">质检状态</span>
            <Select v-model="formData.confirmRightStatusIn" :transfer="true" clearable multiple>
              <Option value="0">待单录</Option>
              <Option value="1">待质检</Option>
              <Option value="2">质检成功</Option>
              <Option value="-1">质检失败</Option>
            </Select>
          </div>
          <div class="input-item">
            <span class="label">退保日期</span>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="formData.refundDate"
              @on-change="formData.refundDate = $event"
              :disabled="formData.refundTimeNull && formData.refundTimeNull.length ? true : false"
            ></DatePicker>
            <CheckboxGroup v-model="formData.refundTimeNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'refundDate')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">险种分类</span>
            <Select v-model="formData.themeIds" placeholder="请选择" clearable multiple filterable>
              <Option v-for="item in productThemeList" :key="item.id" :value="item.id" :label="item.name"> </Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">业务类别</span>
            <Select v-model="formData.sellType" placeholder="请选择" multiple>
              <Option value="1">网销产品</Option>
              <Option value="3">经代产品</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">推荐人机构</span>
            <Select v-model="formData.orgIds" multiple clearable filterable :max-tag-count="1" @on-change="changeOrg">
              <Option v-for="(item, index) in orgList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">奖励归属/推荐人</span>
            <Select placeholder="请选择" v-model="formData.recommendId" clearable filterable>
              <Option v-for="(item, i) in userList" :key="i" :value="item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
              </Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">基础费用归属/被推荐人</span>
            <Select placeholder="请选择" v-model="formData.beRecommendedId" clearable filterable>
              <Option v-for="(item, i) in userList" :key="i" :value="item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
              </Option>
            </Select>
          </div>
        </div>
        <div class="btn-item btn-box">
          <Button type="primary" @click="searchAjax">查询</Button>
          <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll" :disabled="tableData.length ? false : true">全部</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >条，共<span>{{ total }}</span
            >条数据</span
          >
        </div>
      </div>

      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
          <template slot-scope="{ row }" slot="policyStatus">
            <span>{{ row.policyStatus | showPolicyStatusText }}</span>
          </template>

          <template slot-scope="{ row }" slot="calFactor">
            <span>{{ row.calFactor | calFactorText }}</span>
          </template>
        </Table>
      </div>
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px; margin-bottom: 50px"
      />

      <div class="footer-btn">
        <Button type="primary" @click="ok" :loading="loading">加入结算</Button>
        <Button @click="visible = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import { filterTime } from '@/api/filter';

export default {
  mixins: [pageTool, common],
  props: ['reportId'],
  filters: {
    // 保单状态
    showPolicyStatusText(val) {
      switch (val) {
        case '-1':
          return '已退保';
        case '0':
          return '已终止';
        case '1':
          return '已承保';
        case '2':
          return '已中止';
        default:
          return '-';
      }
    },
    // 计算因子
    calFactorText(val) {
      switch (val) {
        case 1:
          return '业务员标保';
        case 2:
          return '业务员规保';
        case 3:
          return '业务员费用';
        default:
          return '-';
      }
    }
  },
  data() {
    return {
      visible: false,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: '批单号',
          width: '160',
          key: 'billNo',
          align: 'center',
          render(h, params) {
            return <span>{params.row.billNo ? params.row.billNo : '-'}</span>;
          }
        },
        {
          title: '所属活动',
          align: 'center',
          key: 'activityNameName',
          minWidth: 160
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'additionName',
          minWidth: 280
        },
        {
          title: '保单状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.status == 1) {
              return <span>已承保</span>;
            } else if (params.row.status == 0) {
              return <span>已终止</span>;
            } else if (params.row.status == 2) {
              return <span>已中止</span>;
            } else if (params.row.status == -1) {
              return <span>已退保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{filterTime(hesitateDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 130
        },
        {
          title: '交费期',
          align: 'center',
          key: 'payDesc',
          minWidth: 120,
          render(h, params) {
            let payDesc = params.row.payDesc;
            return <span>{ payDesc? payDesc : '-' }</span>
          }
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          align: 'center',
          key: 'foldFyb',
          minWidth: 100
        },
        {
          title: '奖励归属',
          align: 'center',
          key: 'recommendName',
          minWidth: 150
        },
        {
          title: '计算因子',
          align: 'center',
          key: 'calFactor',
          minWidth: 130,
          render(h, params) {
            if (params.row.calFactor == 1) {
              return <span>业务员标保</span>;
            } else if (params.row.calFactor == 3) {
              return <span>业务员费用</span>;
            } else if (params.row.calFactor == 2) {
              return <span>业务员规保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '奖励费率',
          align: 'center',
          key: 'rewardRate',
          minWidth: 120,
          render(h, params) {
            return <span>{params.row.rewardRate || 0}%</span>;
          }
        },
        {
          title: '奖励',
          align: 'center',
          key: 'rewardPrice',
          minWidth: 100
        },
        {
          title: '基础费用归属',
          align: 'center',
          key: 'beRecommendedName',
          minWidth: 130
        },
        {
          title: '推荐人团队',
          align: 'center',
          key: 'recommendGroupName',
          minWidth: 150
        },
        {
          title: '推荐人机构',
          align: 'center',
          key: 'recommendOrgName',
          minWidth: 150
        }
      ],
      loading: false,
      dateType: '1',
      dateType2: '1',
      date: [],
      formData: {
        supplierType: '',
        sellType: []
      },
      productList: [],
      companyList: [],
      supplierList: [],
      productThemeJoinVOS: [],
      productThemeList: [], //险种分类
      userList: [], //业务员
      total: null,
      activityId: '',
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      loading: false,
      activityNameName: null,
      selectOrgIds: [],
      orgList: []
    };
  },
  methods: {
    async open(activityId, orgIds, activityNameName, reportType) {
      this.visible = true;
      this.isAll = false;
      this.activityId = activityId;
      this.selectArr = [];
      this.formData.orgIds = [];
      this.formData.sellType = [];
      this.date = [];
      this.dateType = '1';
      this.$set(this, 'selectOrgIds', orgIds);
      this.activityNameName = activityNameName;
      await this.getOrgList(orgIds);
      this.changeSupplierType();
      this.queryProduct();
      this.getBaosi();
      this.getProductTheme();
      this.getUserList(orgIds);
      this.searchAjax();
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 重置
    resetSearch() {
      this.formData = {};
      this.formData.supplierType = '';
      this.formData.sellType = [];
      this.date = [];
      this.dateType = '1';
      this.dateType2 = '1';
      this.formData.orgIds = this.selectOrgIds;
      this.searchAjax();
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.formData.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all';
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list';
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then(res => {
          this.supplierList = res.data;
        });
      }
    },
    changeTimeNull(value, key) {
      this.formData[key] = '';
    },
    parameter() {
      let data = JSON.parse(JSON.stringify(this.formData));
      if (!data.orgIds.length) {
        data.orgIds = this.selectOrgIds;
      }
      if (this.date && this.date[0]) {
        if (this.dateType == 1) {
          //投保日期
          data.holdTimeStart = this.date[0];
          data.holdTimeEnd = this.date[1];
        } else if (this.dateType == 2) {
          //支付日期
          data.payTimeStart = this.date[0];
          data.payTimeEnd = this.date[1];
        } else if (this.dateType == 3) {
          //承保日期
          data.insureTimeStart = this.date[0];
          data.insureTimeEnd = this.date[1];
        } else if (this.dateType == 7) {
          //生效日期
          data.effectTimeStart = this.date[0];
          data.effectTimeEnd = this.date[1];
        }
      }

      if (data.date2 && data.date2[0]) {
        //回执签收日期
        if (this.dateType2 == 1) {
          data.receiptDate2Start = data.date2[0];
          data.receiptDate2End = data.date2[1];
        } else if (this.dateType2 == 2) {
          //回执回销日期
          data.receiptDateStart = data.date2[0];
          data.receiptDateEnd = data.date2[1];
        }
      }
      delete data.date2;
      if (data.dateTimeNull && data.dateTimeNull.length && this.dateType2 == 1) {
        data.receiptDate2IsNull = '1';
        delete data.receiptDate2Start;
        delete data.receiptDate2End;
        delete data.dateTimeNull;
      } else if (data.dateTimeNull && data.dateTimeNull.length && this.dateType2 == 2) {
        data.receiptDateIsNull = '1';
        delete data.receiptDateStart;
        delete data.receiptDateEnd;
        delete data.dateTimeNull;
      } else {
        delete data.dateTimeNull;
      }

      // 回访日期
      if (data.verifyDate && data.verifyDate[0]) {
        data.revisitDateStart = data.verifyDate[0];
        data.revisitDateEnd = data.verifyDate[1];
      }
      delete data.verifyDate;
      if (data.revisitTimeNull && data.revisitTimeNull.length) {
        data.revisitDateIsNull = '1';
        delete data.revisitDateStart;
        delete data.revisitDateEnd;
        delete data.revisitTimeNull;
      } else {
        delete data.revisitTimeNull;
      }

      // 犹豫期止
      if (data.hesitateDate && data.hesitateDate[0]) {
        data.hesitateDateStart = data.hesitateDate[0];
        data.hesitateDateEnd = data.hesitateDate[1];
      }
      delete data.hesitateDate;
      if (data.hesitateTimeNull && data.hesitateTimeNull.length) {
        data.hesitateDateIsNull = '1';
        delete data.hesitateDateStart;
        delete data.hesitateDateEnd;
        delete data.hesitateTimeNull;
      } else {
        delete data.hesitateTimeNull;
      }

      // 退保日期
      if (data.refundDate && data.refundDate[0]) {
        data.refundTimeStart = data.refundDate[0];
        data.refundTimeEnd = data.refundDate[1];
      }
      delete data.refundDate;
      if (data.refundTimeNull && data.refundTimeNull.length) {
        data.refundTimeIsNull = '1';
        delete data.refundTimeStart;
        delete data.refundTimeEnd;
        delete data.refundTimeNull;
      } else {
        delete data.refundTimeNull;
      }

      // 回执状态
      if (data.receiptStatusNull && data.receiptStatusNull.length) {
        data.isNullReceiptStatus = '1';
        delete data.receiptStatusList;
        delete data.receiptStatusNull;
      } else if (data.receiptStatusList == '') {
        delete data.receiptStatusList;
        delete data.receiptStatusNull;
      } else {
        delete data.receiptStatusNull;
      }

      // 回访状态
      if (data.verifyStatusNull && data.verifyStatusNull.length) {
        data.isNullVerifyStatus = '1';
        delete data.verifyStatusList;
        delete data.verifyStatusNull;
      } else if (data.verifyStatusList == '') {
        delete data.verifyStatusList;
        delete data.verifyStatusNull;
      } else {
        delete data.verifyStatusNull;
      }
      return data;
    },
    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/merchantActivity/queryNeedSettlementPolicy',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          recommendOrgIds: this.formData.orgIds,
          ...this.parameter(),
          sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : '',
          activityId: this.activityId
        }
      })
        .then(res => {
          res.data.forEach(item => {
            item.activityNameName = this.activityNameName;
            item.key = item.additionCode +  item.billNo || item.policyNo;
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.key); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.key); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.key) && !selectIds.includes(item.key)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.key);
        } else if (!ids.includes(item.key) && selectIds.includes(item.key)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.key), 1);
          selectIds.splice(selectIds.indexOf(item.key), 1);
        }
      });
    },
    ok() {
      if (!this.isAll && this.selectArr.length == 0) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }
      let params = {};
      if (this.isAll) {
        params = {
          reportId: this.reportId,
          isAll: 1,
          activityRecommendPolicyVOS: this.selectArr,
          merchantActivityRecommendPolicyQuery: {
            ...this.parameter(),
            sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : '',
            activityId: this.activityId
          }
        };
      } else {
        params = {
          reportId: this.reportId,
          isAll: 0,
          activityRecommendPolicyVOS: this.selectArr
        };
      }
      if (this.loading) return;
      this.loading = true;
      this.$http({
        url: '/buz/userSettlementData/saveData',
        type: 'POST',
        data: params
      })
        .then(res => {
          this.visible = false;
          this.$notice.success('加入结算成功');
          this.$emit('success');
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取保司
    getBaosi() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        //赠险公司列表初始化
        this.companyList = res.data;
      });
    },
    // 产品
    queryProduct() {
      this.$http({
        url: '/buz/productBase/read/array',
        type: 'POST',
        data: {}
      }).then(res => {
        this.productList = res.data;
      });
    },
    //险种分类
    getProductTheme() {
      this.$http({
        url: '/buz/productTheme/array/first',
        type: 'GET',
        data: {}
      }).then(res => {
        //赠险公司列表初始化
        this.productThemeList = res.data;
      });
    },
    // 获取机构
    getOrgList(orgIds) {
      return this.$http({
        url: '/buz/organizationBase/queryList',
        type: 'POST',
        data: {
          ids: this.selectOrgIds
        }
      }).then(res => {
        this.orgList = res.data;
        this.$nextTick(() => {
          this.$set(this.formData, 'orgIds', orgIds);
        });
      });
    },
    // 获取当前机构业务员
    getUserList(orgIds = this.formData.orgIds) {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: {
          orgaList: orgIds
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    changeOrg(data) {
      if (!data.length) {
        this.getUserList(this.selectOrgIds);
      } else {
        this.getUserList(data);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  position: relative;
  .search-box {
    margin-top: 20px;
    /deep/.select-two .ivu-select {
      width: 115px !important;
      .ivu-select-selection {
        border-right: 1px solid #dcdee2 !important;
      }
    }
  }
  .btn-box {
    position: absolute;
    bottom: 13px !important;
    right: -10px;
  }
  .dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: top;
    transform: translateY(7px);
    &.red {
      background: #e3461f;
    }
    &.orange {
      background: #ff9900 !important;
    }
  }
}
/deep/ .ivu-icon-ios-close {
  color: #3c464f !important;
}
/deep/.ivu-modal-close {
  top: 0px;
  font-size: 30px;
}
/deep/.ivu-modal-header {
  height: 45px;
  padding-left: 20px;
}
/deep/.ivu-modal-header-inner {
  font-size: 16px;
}
.footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
</style>
